'use strict';

/**
 * 変動スピード
 * 
 * @protected
 * @constant {number}
 */
const SPIN_SPEED = 20;

/**
 * スピナーコントロール用配列
 * グローバルに使用するため定義
 */
let arySpinnerCtrl = [];

/**
 * 変動計算する関数。
 * スピナー値の最大値や最小値を超えないように制御
 * 
 */
function spinnerCal(){
    let target = $(arySpinnerCtrl['.target']);
    // 現在の値を取得
    let num = Number(target.val());
    // 数量を加算
    num += arySpinnerCtrl['.cal'];
    if(num > Number(target.data('max'))){
        // 最大値を超える場合、最大値をセット
        target.val(Number(target.data('max')));
    }else if(Number(target.data('min')) > num){
        // 最大値を超える場合、最大値をセット
        target.val(Number(target.data('min')));
    }else{
        target.val(num);
    }
}

/**
 * 数量変更スピナー
 */
function quantityChange() {
    
    // 数量変更ボタン長押し時
    $('.btnspinner').on('touchstart mousedown click', function(e){
        if(arySpinnerCtrl['.interval']) return false;
        // 入力フィールドを示すオブジェクトを取得
        let target = $(this).data('target');
        arySpinnerCtrl['.target'] = target;
        arySpinnerCtrl['.timestamp'] = e.timeStamp;
        // 数量の増減値を格納
        arySpinnerCtrl['.cal'] = Number($(this).data('cal'));

        // クリックは単一の処理に留める
        if(e.type === 'click'){
            spinnerCal();
            arySpinnerCtrl = [];
            return false;
        }

        // 長押し時の処理
        setTimeout(function(){
            // インターバル未実行中 + 長押しのイベントタイプスタンプ一致時に計算処理
            // 長押しから500ミリ秒後に処理が実行される
            if(!arySpinnerCtrl['.interval'] && arySpinnerCtrl['.timestamp'] === e.timeStamp){
                arySpinnerCtrl['.interval'] = setInterval(spinnerCal, SPIN_SPEED);
            }
        }, 500);
    });
    
    // 長押し解除時 画面スクロールも解除に含む
    $(document).on('touchend mouseup scroll', function(e){
        if(arySpinnerCtrl['.interval']){
            // スピナーの変動を停止するために値をクリア
            clearInterval(arySpinnerCtrl['.interval']);
            arySpinnerCtrl = [];
        }
    });
}

module.exports = {
    quantityChange
};